import { lazy, type ComponentType, type LazyExoticComponent } from 'react';
import type { WidgetDataMap, WidgetType } from '@/types/widgets';

// TO-DO: implement error boundary

// import WidgetErrorBoundary from './WidgetErrorBoundary';

// const withErrorBoundary = <P extends object>(
//   Component: React.ComponentType<P>
// ) => {
//   return (props: P) => (
//     <WidgetErrorBoundary>
//       <Component {...props} />
//     </WidgetErrorBoundary>
//   );
// };

const HomePageProductList = lazy(() => import('./HomePageProductList'));
const CurationWidget = lazy(
  () => import('@/components/widgets/CurationWidget')
);
const StaticSearchBar = lazy(() => import('./StaticSearchBar'));
const DividerWidget = lazy(() => import('./DividerWidget'));
const GenericCtaWidget = lazy(() => import('./GenericCtaWidget'));
const CategoryWidget = lazy(() => import('./CategoryWidget'));

export const widgetRegistry = {
  HOME_PAGE_PRODUCT_LIST: HomePageProductList,
  STATIC_SEARCH_BAR: StaticSearchBar,
  DIVIDER_WIDGET: DividerWidget,
  CURATION_WIDGET: CurationWidget,
  GENERIC_CTA_WIDGET: GenericCtaWidget,
  CATEGORY_WIDGET: CategoryWidget,
} satisfies {
  [K in WidgetType]: LazyExoticComponent<ComponentType<WidgetDataMap[K]>>;
};

export type WidgetRegistry = typeof widgetRegistry;
export type WidgetComponent<T extends WidgetType> = WidgetRegistry[T];
